var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix screen"},[_c('Class',{staticClass:"pull-left class"}),_c('Banner',{staticClass:"pull-left banner"}),_c('User',{staticClass:"pull-right user"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }